import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFuelConsumptionRate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17.521,
	height: 20.069,
	viewBox: "0 0 17.521 20.069",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_7792",
		"data-name": "Group 7792",
		transform: "translate(-196.597 -410.124)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_19328",
			"data-name": "Path 19328",
			d: "M213.475,417.747a1.887,1.887,0,0,0,.354-.835,2.6,2.6,0,0,0-.451-1.938,5.864,5.864,0,0,0-1.255-1.271.214.214,0,0,0-.025-.029.427.427,0,0,0-.118-.083l0,0a7.7,7.7,0,0,0-1.581-.936,7.351,7.351,0,0,0-1.761-.514.436.436,0,0,0-.14.86,6.459,6.459,0,0,1,2.646,1.061,2.292,2.292,0,0,0-.478,1.938,4.168,4.168,0,0,0,1.462,2.137c-.014.26-.014.524-.014.792,0,.337.011.664.029.984.043.812.157,1.586.272,2.354a22.078,22.078,0,0,1,.268,2.365,4.146,4.146,0,0,1-.326,2.12,1.208,1.208,0,0,1-1.2.6h-.008a1.342,1.342,0,0,1-1.312-1.18,10.127,10.127,0,0,1,.1-3.985.316.316,0,0,0,.006-.075,8.56,8.56,0,0,0-.667-3.736A2.579,2.579,0,0,0,207.5,416.9v-4.2a2.327,2.327,0,0,0-2.322-2.324H199.16a2.317,2.317,0,0,0-2.313,2.312v17.257h10.63L207.5,417.8a1.833,1.833,0,0,1,1,.96,7.688,7.688,0,0,1,.575,3.3,10.843,10.843,0,0,0-.078,4.325,2.138,2.138,0,0,0,2.137,1.825,2.014,2.014,0,0,0,1.983-1.037,4.911,4.911,0,0,0,.44-2.583,22.243,22.243,0,0,0-.274-2.457c-.113-.755-.226-1.516-.266-2.271q-.028-.484-.029-.94c0-.237,0-.476.013-.72A2.151,2.151,0,0,0,213.475,417.747Zm-6.849,11.209H197.72V412.687a1.446,1.446,0,0,1,1.44-1.44h6.015a1.457,1.457,0,0,1,1.451,1.451v16.258Zm6.346-12.18a1,1,0,0,1-.19.452,1.145,1.145,0,0,1-.164.177,3.237,3.237,0,0,1-1.1-1.585,1.47,1.47,0,0,1,.317-1.226h0a4.3,4.3,0,0,1,.819.868A1.768,1.768,0,0,1,212.972,416.776Z",
			fill: "var(--ant-primary-color)",
			stroke: "var(--ant-primary-color)",
			strokeWidth: .5
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_19329",
			"data-name": "Path 19329",
			d: "M205.186,412.822a.875.875,0,0,0-.624-.26h-4.688a.88.88,0,0,0-.589.228.346.346,0,0,0-.035.032.875.875,0,0,0-.26.624v2.991a.888.888,0,0,0,.883.884h4.689a.886.886,0,0,0,.884-.884v-2.991a.878.878,0,0,0-.228-.589A.268.268,0,0,0,205.186,412.822Zm-.618,3.613v.006h-4.7v-3.006h4.692v.008h.006Z",
			fill: "var(--ant-primary-color)",
			stroke: "var(--ant-primary-color)",
			strokeWidth: .5
		})]
	})]
});
const ForwardRef = forwardRef(SvgFuelConsumptionRate);
export default ForwardRef;
